import { h } from 'preact';
import { Localizer } from 'preact-i18n';
import style from './style';
import cx from 'classnames';

export default function ToggleButtonText({ iconPosition, icon, value, title }) {
	if (!title && typeof(value) !== 'object') title = value;
	return (
		<div class={style[iconPosition]}>
			{ iconPosition === 'left' && icon }
			{ iconPosition === 'floatLeft' && icon }
			<Localizer>
				<p class={cx(style.toggle)} title={title}>
					{value}
				</p>
			</Localizer>
			{ iconPosition === 'right' && icon }
			{ iconPosition === 'floatRight' && icon }
		</div>
	);
}
